import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { formRender, initialValues, skuPackTypeValidation } from "./sku-pack-type-schema";
import SKUPackTypeInfo from "./components/SKUPackTypeInfo";
import { useLocation } from "react-router-dom";
import { editSKUPackType } from "services/data.internal.service";
import { SaveButton } from "ui-components/Form";
import { getSKUPackTypeByCode } from "services/data.internal.service";
import { validateData } from "./add-sku-pack-type";
import { LoadingDialog } from "ui-components/Alert";
import { WarningAlert } from "ui-components/Alert";
const palletTypeOptions = {
  SMALL: { label: "Small Pallet", value: "SMALL" },
  STANDARD: { label: "Standard Pallet", value: "STANDARD" },
  LARGE: { label: "Large Pallet", value: "LARGE" },
};

function EditSKUPackType() {
  const location = useLocation();
  const { skuCode, customerCode, vendorCode } = location.state;
  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState(null);
  const [lotAttribute, setLotAttribute] = useState(true);
  const queryClient = useQueryClient();

  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const { isFetching } = useQuery({
    queryKey: ["sku-pack-type", { skuCode, customerCode, vendorCode }],
    queryFn: () => getSKUPackTypeByCode({ skuCode, customerCode, vendorCode }),
    onSuccess: (data) => {
      const { palletType, editable, ...values } = data.data.data;
      console.log(palletType ? palletTypeOptions[palletType] : null);
      setFormValues({ ...values, palletType: palletType ? palletTypeOptions[palletType] : null });
      setLotAttribute(editable);
    },
    onError,
  });
  const editSKUPackTypeMutation = useMutation(editSKUPackType, {
    onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    values: formValues,
    resolver: yupResolver(skuPackTypeValidation),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isDirty, isSubmitting },
  } = form;

  const infoProps = {
    mode: "EDIT",
    control,
    errors,
    formRender,
    lotAttribute,
    // Server-loaded value, frozen at fetch time - not the live form value being typed into.
    initialUpmCase: formValues?.upmCase,
  };
  const onSubmit = (data) => {
    window.scrollTo(0, 0);
    // const validate = validateData(data);
    // if (validate.length > 0) {
    //   setAlert(<Error_ content={validate.join(",")} onChange={setAlert} />);
    //   return;
    // }
    editSKUPackTypeMutation.mutate({ ...data, palletType: data.palletType?.value },{onSuccess:()=>queryClient.invalidateQueries(["sku-pack-type"])});
  };
  return (
    <Layout lg={12}>
      {!lotAttribute && <WarningAlert content="Not allow to edit, SKU pack type is in use" />}
      {isFetching && <LoadingDialog />}
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <SKUPackTypeInfo {...infoProps} />
        <SaveButton label="save" disabled={!isDirty || isSubmitting} url={-1} />
      </form>
    </Layout>
  );
}

export default EditSKUPackType;
